const UserManagementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M21 11H16C14.346 11 13 12.346 13 14V21C13 22.654 14.346 24 16 24H21C22.654 24 24 22.654 24 21V14C24 12.346 22.654 11 21 11ZM22 21C22 21.551 21.552 22 21 22H16C15.448 22 15 21.551 15 21V14C15 13.449 15.448 13 16 13H21C21.552 13 22 13.449 22 14V21ZM21 15.997C21 16.549 20.553 16.997 20 16.997H17C16.447 16.997 16 16.549 16 15.997C16 15.445 16.447 14.997 17 14.997H20C20.553 14.997 21 15.445 21 15.997ZM21 19C21 19.552 20.553 20 20 20H17C16.447 20 16 19.552 16 19C16 18.448 16.447 18 17 18H20C20.553 18 21 18.448 21 19ZM9 12C12.309 12 15 9.309 15 6C15 2.691 12.309 0 9 0C5.691 0 3 2.691 3 6C3 9.309 5.691 12 9 12ZM9 2C11.206 2 13 3.794 13 6C13 8.206 11.206 10 9 10C6.794 10 5 8.206 5 6C5 3.794 6.794 2 9 2ZM11 15C11 15.552 10.553 16 10 16H9C5.141 16 2 19.14 2 23C2 23.552 1.553 24 1 24C0.447 24 0 23.552 0 23C0 18.038 4.037 14 9 14H10C10.553 14 11 14.448 11 15Z"  />
    </svg>
  );
};

export default UserManagementIcon;
